// services/Logger.ts
import type {RootState} from "@app/store"

import { store } from "@app/store";
import { addLog, clearLogs } from "@app/data/logger/loggerSlice";
import { LogLevel } from "./type";

class Logger {
  log(message: string, details?: Record<string, any>) {
    this._dispatch(message, 'log', details);
    console.log(`[LOG]: ${message}`, details);
  }

  info(message: string, details?: Record<string, any>) {
    this._dispatch(message, 'info', details);
    console.info(`[INFO]: ${message}`, details);
  }

  warn(message: string, details?: Record<string, any>) {
    this._dispatch(message, 'warn', details);
    console.warn(`[INFO]: ${message}`, details);
  }

  error(message: string, details?: Record<string, any>) {
    this._dispatch(message, 'error', details);
    console.error(`[ERROR]: ${message}`, details);
  }

  clear() {
    store.dispatch(clearLogs());
    console.clear();
  }

  private _dispatch(message: string, level: LogLevel, details?: Record<string, any>) {
    store.dispatch(addLog({ message, level, details }));
  }
}

export const logger = new Logger();
